module.exports = __webpack_public_path__ + "static/media/toiyabe-logo-only.cb70cbe8.png";